<template>
    <div class="content">
        <div class="my-title">
            <Row :gutter="10">
                <Col span="12"> 草稿箱</Col>
            </Row>
        </div>
        <Tabs v-model="status">
            <TabPane label="投保单" name="0">
                <i-table :columns="columns" url="/broker/insurance/application/pageList.json" :params="params"
                    ref="table0">
                    <template slot-scope="{ row,index }" slot="action">
                        <a @click="tolink(row)">办理</a>
                        <a @click="del(row)" v-if="!row.procId">删除</a>
                    </template>
                </i-table>
            </TabPane>
            <TabPane label="批改单" name="1">
                <i-table :columns="columns2" url="/broker/insurance/endorse/list.json" :params="params2" ref="table1">
                    <template slot-scope="{ row,index }" slot="action">
                        <a :href="toCorrect(row)" target="_blank">办理</a>
                        <!-- <a @click="del(row)">撤销</a> -->
                    </template>
                </i-table>
            </TabPane>
        </Tabs>
        <!-- <div class="orders">
            <i-table :columns="columns" url="/broker/insurance/application/pageList.json" :params="params" ref="table">
                <template slot-scope="{ row,index }" slot="action">
                    <a :href="getAgentUrl(row)" target="_blank">办理</a>
                    <a @click="del(row)">撤销</a>
                </template>
            </i-table>
        </div> -->
    </div>
</template>
<script>
    import PolicyItem from '../common/PolicyItem'
    import ITable from '@/components/common/ITable'
    import { getAgentUrl } from '@/common/agent'
    import { mapState } from 'vuex'
    export default {
        components: { PolicyItem, ITable },
        data () {
            return {
                status: '0',
                getAgentUrl: getAgentUrl,
                params: {
                    insuranceApplicationStatus: 'UNCONFIRMED',
                    bizId: 'JIANGONG_EMPLOYER_LIABILITY',
                },
                params2: {
                    endorseStatus: 'UNCONFIRMED',
                    bizId: 'JIANGONG_EMPLOYER_LIABILITY',
                },
                columns: [
                    { title: '险种', key: 'productName', width: 240 },
                    { title: '保险公司', key: 'companyName' },
                    { title: '更新日期', key: 'updateTime', width: 180 },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 100,
                        align: 'center'
                    }
                ],
                columns2: [
                    { title: '批改单号', key: 'endorseNo' },
                    { title: '险种', key: 'productName', width: 200 },
                    { title: '保险公司', key: 'insuranceCompanyName', width: 300 },
                    { title: '提交日期', key: 'createTime', width: 180 },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 100,
                        align: 'center'
                    }
                ],
            }
        },
        watch: {
            status (v) {
                this.$refs['table' + v].getList()
            },
            userInfo (v) {
                this.checkLogin()
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.common.info
            }),
        },
        created () {
            this.checkLogin()
        },
        methods: {
            tolink(row){
                window.location.href = this.getAgentUrl(row)
            },
            // 检测登录
            checkLogin () {
                if (!this.userInfo.userId) {
                    if (location.href && location.href.indexOf('/common.html#/login') == -1) {
                        window.location = location.origin + '/common.html#/login?bankUrl=' + encodeURIComponent(location.href);
                    }
                    return false
                } else {
                    return true
                }
            },
            // 撤销操作
            async del (data) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '确定进行删除操作？',
                    onOk: () => {
                        this.$axios.post('/broker/insurance/application/cancelApplication', { applicationId: data.insuranceApplicationId }).then(res => {
                            this.toast('操作成功')
                            this.$refs['table' + this.status].getList()
                        })
                    }
                })
            },
            // 去批单
            toCorrect (data) {
                let url = '/agent.html#/agent/review/' + data.endorseId
                url = url + '?insurancePolicyId=' + data.insurancePolicyId + '&insuranceApplicationId=' + data.insuranceApplicationId
                // url=`${url}?insurancePolicyId=${data.insurancePolicyId}&insuranceApplicationId=${data.insuranceApplicationId}&
                // cntrNo=${data.cntrNo}&companyName=${data.companyName}&productName=${data.productName}`
                return url
            }
        }
    }
</script>
<style scoped>
    .content {
        padding: 0 15px 15px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customized/draft.vue